<template>
  <div>
    <h4 class="title">Вы в социальных сетях</h4>
    <span
      class="description"
    >Заполни свои соц сети, что бы клиентам было удобно узнать о тебе, твоих скиллах и портфолио</span>
   <span v-for="(social,key) in contacts.socials" :key="key">
      <Inputs
        class="group"
        type="text"
        :placeholder="social.placeholder"
        :subholder="social.subholder"
        :name="social.name"
        v-on:input="oninput"
        :value="social.link"
      ></Inputs>
    </span>
    <div class="btn-wrap">
      <router-link to="/profile/step/1/" class="btn btn-outline-primary">Назад</router-link>
      <router-link to="/profile/step/3/" class="btn btn-primary">Следующий шаг</router-link>
    </div>
  </div>
</template>

<script>
import Inputs from "@/components/basic/Input.vue";
export default {
  name: "Step2",
  components: {
    Inputs
  },
  props: ["contacts"],
  data() {
    return {};
  },
  methods: {
    oninput: function(val, target) {
      this.$emit("print", target.name, val, true);
    },
  }
};
</script>

<style lang="scss" scoped>
</style>